export default {
  init() {
    const epiForms = window.$$epiforms
    if (!epiForms) {
      return
    }
    const headerHeight = 80

    epiForms(document).ready(() => {
      epiForms('.EPiServerForms').on('formsSubmitted', (e) => {
        if (e.isFinalizedSubmission && e.isSuccess) {
          const currentForm = e.currentTarget
          window.scrollTo({
            top: currentForm.offsetTop - headerHeight,
            left: 0,
            behavior: 'smooth'
          })
          if (window.dataLayer) {
            const formName = e.workingFormInfo.Name || 'contact form'
            window.dataLayer.push({
              event: 'formSubmit',
              formName,
              formType: 'contact'
            })
          }
        }
      })
    })
  }
}
